var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Avatar, Button, CardContent, Typography } from '@material-ui/core';
import cx from 'clsx';
import { Emphasize } from './Emphasize';
export function QAContent(_a) {
    var question = _a.question, onClick = _a.onClick, info = _a.info, className = _a.className, LinkComponent = _a.LinkComponent;
    var buttonProps = {};
    if (onClick) {
        buttonProps.onClick = onClick;
    }
    if (LinkComponent) {
        buttonProps.component = LinkComponent;
    }
    return (_jsx(CardContent, { className: cx('faq-panel-content', className), children: _jsxs(Button, __assign({ color: "inherit", fullWidth: true, className: cx('faq-panel-content-button', 'faq-panel-content__button') }, buttonProps, { children: [_jsx(Avatar, { className: "faq-panel-content__avatar", children: info ? '!' : 'Q' }), _jsx(Typography, { className: "faq-panel-content__q", variant: "h5", children: _jsx(Emphasize, { target: question || '' }) })] })) }));
}
//# sourceMappingURL=QAContent.js.map